module.exports = __webpack_public_path__ + "static/media/default_asahi_sora6cefc5f4892d2cb390f37835ca86d9bf.webp";